import _ from 'lodash';
import { ChangeDetectorRef, Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { loadReportCampaignList } from 'app/campaign/features/campaign.actions';
import { selectCampaignList } from 'app/campaign/features/campaign.selectors';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { map, Observable } from 'rxjs';
import { DialogService } from 'app/dialog/services/dialog.service';
import { UntypedFormControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-add-on-donation',
  templateUrl: './add-on-donation.component.html',
  styleUrl: './add-on-donation.component.scss'
})
export class AddOnDonationComponent implements OnInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));
  public addOnDonationCampaignEnabled: UntypedFormControl = new UntypedFormControl(false);
  public addOnDonationCampaignId: UntypedFormControl = new UntypedFormControl('');
  public dialog: any = null;
  public showSelectError = false;
  public campaignsList = [];
  public selectedId = null;

  constructor(   
     public store: Store,
     public sharedService: SharedService,
     public dialogService: DialogService,
     private cdr: ChangeDetectorRef,
     ){
  }

  public donations$: any = this.store.pipe(
    select(selectCampaignList),
    map(list => {
      return _.filter(list, { status: 0, type: CAMPAIGN_TYPE.DONATE });
    })
  )

  ngOnInit(): void {
    if(this.sharedService.token) {}
    this.store.dispatch({
      type: loadReportCampaignList.type,
      payload: this.sharedService.token
    });
    
    this.addOnDonationCampaignId.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(data => {
     this.showSelectError = false;
    });

    this.dialog$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((dialog) => {
      this.dialog = dialog;
      const { initialState: { selectedCampId } } = dialog;
      this.selectedId = selectedCampId;

      if(selectedCampId){
        this.addOnDonationCampaignId.setValue(selectedCampId)
        this.addOnDonationCampaignEnabled.setValue(true);
      }else{
        this.addOnDonationCampaignId.setValue('')
        this.addOnDonationCampaignEnabled.setValue(false);
      }
    })

    this.donations$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((list)=>{
      if(list && list.length > 0){
        this.campaignsList = list;
        let selectedCamp =  this.campaignsList.find(camp=>(camp.id==this.selectedId));
        if(!selectedCamp){
          this.addOnDonationCampaignId.setValue('')
          this.addOnDonationCampaignEnabled.setValue(false);
          this.cdr.markForCheck();
        }
      }
    })
  }

  close(dialog, value) {
    this.dialogService.closeDialogSubject.next(value);
    
    const { initialState: { action, callback  } } = dialog;
    if(value) {
      if(action) {
        this.store.dispatch(action);
      }
      let campaignId = this.addOnDonationCampaignId.value
      let enable = this.addOnDonationCampaignEnabled.value
      let name = '';
      this.donations$.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(list=>{
        let selectedCamp = list.find((cam)=>(cam.id==campaignId))
        if(selectedCamp){
          name = selectedCamp.name
        }
      })
      let data = {campaignId,enable,name}
      callback(data);
    }
  }

  onConfirm(dialog, value){
    let selectedCampaignId = this.addOnDonationCampaignId.value;
    let addOnDonationCampaignEnabled = this.addOnDonationCampaignEnabled.value;

    if(!addOnDonationCampaignEnabled){
      this.close(dialog, value);
    }

    if(selectedCampaignId){
      this.close(dialog, value);
    }else{
      this.showSelectError = true;
    }

  }

 ngOnDestroy(){
  this.addOnDonationCampaignId.setValue('')
  this.addOnDonationCampaignEnabled.setValue(false);
 }
}
